import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=060270ed&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=ts&"
export * from "./CourseList.vue?vue&type=script&lang=ts&"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=060270ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060270ed",
  null
  
)

export default component.exports